<template>
    <el-row
        :gutter="15"
        style="height: 100%"
        class="content-form"
        v-loading="loading"
    >
        <el-form
            ref="form"
            :model="form"
            :inline="true"
            label-width="90px"
            :rules="rules2"
        >
            <el-col :sm="24" class="add_infoDiv">
                <div class="add_info_title">
                    添加咨询工单
                    <span class="info_btn">
                        <i class="el-icon-minus"></i>
                        <i class="el-icon-close" @click.stop="close"></i>
                    </span>
                </div>
                <div class="clearfix">
                    <el-button size="medium" plain>打印</el-button>
                </div>
            </el-col>
            <el-col :sm="24" class="add_infoDiv">
                <div class="add_info_title1">咨询工单信息</div>
                <div class="clearfix">
                    <div class="fl add_infoItem">
                        <div class="addOrg-div clearfix">
                            <label class="fl form-label">工单流水号</label>
                            <el-input
                                class="fl form-input"
                                v-model="orderNum"
                                readonly
                            ></el-input>
                        </div>

                        <div class="addOrg-div clearfix">
                            <label class="fl form-label">咨询客户</label>
                            <el-input
                                class="fl form-input"
                                v-model="form.name"
                                placeholder="请输入客户姓名"
                                @click.native="inputClickName"
                            ></el-input>
                            <div
                                class="table-expand expandName"
                                v-if="tableExpandName"
                            >
                                <div class="table-search clearfix">
                                    <div class="clearfix fl">
                                        <label class="fl form-label"
                                            >姓名</label
                                        >
                                        <el-input
                                            class="fl form-input"
                                            v-model="form1.name"
                                        ></el-input>
                                    </div>
                                    <div class="clearfix fl">
                                        <label class="fl form-label"
                                            >地址</label
                                        >
                                        <el-input
                                            class="fl form-input"
                                            v-model="form1.adddress"
                                        ></el-input>
                                    </div>
                                </div>
                                <div class="table-search clearfix">
                                    <div class="fl">
                                        <label class="fl form-label"
                                            >联系方式</label
                                        >
                                        <el-input
                                            class="fl form-input"
                                            v-model="form1.phone"
                                        ></el-input>
                                    </div>
                                    <div class="fl">
                                        <label class="fl form-label"
                                            >用户类型</label
                                        >
                                        <el-select
                                            class="fl form-input"
                                            v-model="form1.type"
                                            placeholder="请输入"
                                        >
                                            <el-option
                                                label="商业客户"
                                                value="7"
                                            ></el-option>
                                            <el-option
                                                label="民政客户"
                                                value="6"
                                            ></el-option>
                                            <el-option
                                                label="老干客户"
                                                value="4"
                                            ></el-option>
                                            <el-option
                                                label="残联客户"
                                                value="3"
                                            ></el-option>
                                        </el-select>
                                    </div>
                                    <el-button
                                        type="primary"
                                        size="small"
                                        icon="el-icon-search"
                                        @click.native="inputClickName"
                                        >过滤</el-button
                                    >
                                    <el-button
                                        size="medium"
                                        type="danger"
                                        @click.native="inputClosekName"
                                        >关闭</el-button
                                    >
                                </div>
                                <el-table
                                    class="form-table"
                                    :data="tableDatas"
                                    stripe
                                    tooltip-effect="dark"
                                    style="width: 100%"
                                >
                                    <el-table-column
                                        fixed
                                        prop="index"
                                        label="序号"
                                        width="50"
                                    >
                                    </el-table-column>
                                    <el-table-column
                                        prop="name"
                                        label="姓名"
                                        show-overflow-tooltip
                                    >
                                    </el-table-column>
                                    <el-table-column
                                        prop="phone"
                                        show-overflow-tooltip
                                        label="联系方式"
                                    >
                                    </el-table-column>
                                    <el-table-column
                                        prop="isFree"
                                        :formatter="isFreeFormat"
                                        show-overflow-tooltip
                                        label="是否实体"
                                    >
                                    </el-table-column>
                                    <el-table-column
                                        prop="type"
                                        :formatter="typeFormat"
                                        show-overflow-tooltip
                                        label="用户类型"
                                    >
                                    </el-table-column>
                                    <el-table-column
                                        prop="address"
                                        show-overflow-tooltip
                                        label="地址"
                                    >
                                    </el-table-column>
                                    <el-table-column
                                        prop="opt"
                                        label="操作对象"
                                    >
                                        <template slot-scope="scope">
                                            <i
                                                class="el-icon el-icon-1"
                                                title="选择"
                                                @click.stop="
                                                    change(scope.row.id)
                                                "
                                            ></i>
                                        </template>
                                    </el-table-column>
                                </el-table>
                                <Paginationmini
                                    :pageConfig="pageConfig3"
                                    @currentPage="currentChange3"
                                    @pageSize="pageSizeChange3"
                                ></Paginationmini>
                            </div>
                        </div>
                        <div class="addOrg-div clearfix">
                            <label class="fl form-label">受理人员</label>
                            <el-input
                                class="fl form-input"
                                v-model="loginName"
                                readonly
                            ></el-input>
                        </div>
                        <div class="addOrg-div clearfix">
                            <label class="fl form-label">咨询备注</label>
                            <el-input
                                type="textarea"
                                class="fl form-input"
                                v-model="remark"
                                placeholder="请输入咨询备注"
                            ></el-input>
                        </div>
                        <div
                            class="clearfix"
                            style="
                                width: 667px;
                                margin-bottom: 15px;
                                color: red;
                                padding-left: 40px;
                                font-size: 30px;
                            "
                        >
                            <el-form-item
                                style="padding-left: 10px"
                                label="咨询内容"
                                prop="adviceContent"
                            >
                                <el-input
                                    type="textarea"
                                    class="fl form-input"
                                    style="width: 450px"
                                    v-model="form.adviceContent"
                                    placeholder="请输入咨询内容"
                                ></el-input> </el-form-item
                            >*
                        </div>
                        <div
                            class="clearfix"
                            style="
                                width: 667px;
                                margin-bottom: 15px;
                                padding-left: 40px;
                                color: red;
                                font-size: 30px;
                                margin-top: 10px;
                            "
                        >
                            <el-form-item label="咨询回复" prop="adviceAnswer">
                                <el-input
                                    type="textarea"
                                    class="fl form-input"
                                    style="
                                        padding-left: 15px;
                                        width: 450px;
                                        margin-top: 10px;
                                    "
                                    v-model="form.adviceAnswer"
                                    placeholder="请输入咨询回复"
                                ></el-input> </el-form-item
                            >*
                        </div>
                        <!-- <div class="addOrg-div clearfix">
                        <label class="fl form-label">咨询内容</label>
                        <el-input type="textarea" class="fl form-input" v-model="adviceContent" placeholder="请输入"></el-input>
                    </div>
                     <div class="addOrg-div clearfix">
                        <label class="fl form-label">咨询回复</label>
                        <el-input type="textarea" class="fl form-input" v-model="adviceAnswer" placeholder="请输入"></el-input>
                    </div> -->
                    </div>
                    <div class="fl add_infoItem">
                        <div class="addOrg-div clearfix">
                            <label class="fl form-label">来电时间</label>
                            <el-input
                                class="fl form-input"
                                v-model="callTime"
                                readonly
                            ></el-input>
                        </div>
                        <div
                            class="clearfix"
                            style="
                                width: 667px;
                                padding-left: 40px;
                                margin-bottom: 15px;
                                color: red;
                                font-size: 30px;
                            "
                        >
                            <el-form-item
                                style="padding-left: 10px"
                                label="来电号码"
                                prop="counter"
                            >
                                <el-input
                                    class="fl form-input"
                                    style="width: 450px"
                                    v-model="form.counter"
                                    placeholder="请输入来电号码"
                                ></el-input> </el-form-item
                            >*
                        </div>
                        <div
                            class="clearfix"
                            style="
                                padding-left: 40px;
                                width: 667px;
                                margin-bottom: 15px;
                                color: red;
                                font-size: 30px;
                            "
                        >
                            <el-form-item
                                style="padding-left: 10px"
                                label="咨询类别"
                                prop="firstType"
                            >
                                <el-select
                                    class="fl form-input"
                                    style="width: 450px"
                                    v-model="form.firstType"
                                    @click.native="selectTypeName()"
                                    @change="changeValue"
                                    placeholder="请选择咨询类别"
                                >
                                    <el-option
                                        v-for="item in options"
                                        :label="item.typeName"
                                        :key="item.id"
                                        :value="item.id"
                                    >
                                    </el-option>
                                </el-select>
                                <!-- <el-input class="fl form-input" style="width:330px;" v-model="form.typeName" placeholder="请选择咨询类别"></el-input> --> </el-form-item
                            >*
                        </div>
                        <!-- <div class="addOrg-div clearfix">
                        <label class="fl form-label">咨询类别</label>
                         <el-select class="fl form-input" v-model="form.firstType"  @click.native="selectTypeName()" @change="changeValue" placeholder="请选择" >
                            <el-option v-for="item in options" :label="item.typeName" :key="item.id" :value="item.id"> </el-option>                          
                        </el-select>
                    </div> 
                    <div class="addOrg-div clearfix">
                        <label class="fl form-label">来电号码</label>
                        <el-input class="fl form-input" v-model="counter" ></el-input>
                    </div> -->
                        <div class="addOrg-div clearfix">
                            <label class="fl form-label">受理坐席</label>
                            <el-input
                                class="fl form-input"
                                v-model="seatNo"
                                readonly
                            ></el-input>
                        </div>
                    </div>
                </div>
                <div class="clearfix bottom-btn">
                    <el-button type="primary" @click="saveBtn('form')"
                        >保存</el-button
                    >
                </div>
            </el-col>
        </el-form>
    </el-row>
</template>

<script>
import { metaDataMgrDao } from "@/api/dao.js"
import Paginationmini from "../add/pagination-mini"
export default {
    props: ["id"],
    data: function () {
        var checkcounter = (rule, value, callback) => {
            if (!value) {
                return callback(new Error("来电号码不能为空"))
            } else {
                callback()
            }
        }
        var checkadviceAnswer = (rule, value, callback) => {
            if (!value) {
                return callback(new Error("咨询回复不能为空"))
            } else {
                callback()
            }
        }
        var checkadviceContent = (rule, value, callback) => {
            if (!value) {
                return callback(new Error("咨询内容不能为空"))
            } else {
                callback()
            }
        }
        var checkfirstType = (rule, value, callback) => {
            if (!value) {
                return callback(new Error("咨询类型不能为空"))
            } else {
                callback()
            }
        }
        return {
            counters: this.id,
            loginName: "",
            callTime: "",
            counter: "",
            remark: "",
            seatNo: "",
            orderNum: "",
            adviceContent: "",
            adviceAnswer: "",
            tableExpand: false,
            tableExpandjms: false,
            tableExpandzyz: false,
            tableExpandName: false,
            tableExpandClass: false,
            loading: false,
            belongAddressId: "",
            belongProvinceId: "",
            belongAddressLevel: "",
            tableData: [],
            tableDatas: [],
            fileList2: [],
            options: [],
            pageConfig3: {
                pageSize: 4,
                total: 0,
                pageNo: 1,
            },
            form: {
                customerId: "",
                adviceType: "",
                adviceContent: "",
                adviceAnswer: "",
                counter: "",
                name: "",
            },
            rules2: {
                counter: [{ validator: checkcounter, trigger: "blur" }],
                adviceAnswer: [
                    { validator: checkadviceAnswer, trigger: "blur" },
                ],
                adviceContent: [
                    { validator: checkadviceContent, trigger: "blur" },
                ],
                firstType: [{ validator: checkfirstType, trigger: "blur" }],
            },
            form1: {
                name: "",
                address: "",
                type: "",
                phone: "",
                productName: "",
                productNameId: "",
                customerId: "",
            },
        }
    },
    methods: {
        typeFormat(row, column) {
            if (row.type === 7) {
                return "商业客户"
            } else if (row.type === 6) {
                return "民政客户"
            } else if (row.type === 4) {
                return "老干客户"
            } else if (row.type === 3) {
                return "残联客户"
            }
        },
        isFreeFormat(row, column) {
            if (row.isFree === "0") {
                return "否"
            } else if (row.isFree === "1") {
                return "是"
            }
        },
        //咨询类别
        selectTypeName() {
            var formData = new FormData()
            formData.append("pageSize", "50")
            formData.append("pageNo", "1")
            if (this.belongAddressLevel == "1") {
                formData.append("belongProvinceId", this.belongProvinceId)
            } else {
                formData.append("belongAddressId", this.belongAddressId)
            }
            metaDataMgrDao.findAdviceType(formData).then((resp) => {
                if (resp.code == "200") {
                    this.options = []
                    console.log(resp)
                    let list = resp.content.list
                    this.options = this.options.concat(list)
                }
                this.tableLoading = false
                console.log(resp)
            })
        },
        changeValue(value) {
            this.form.adviceType = value
        },
        saveBtn(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    this.loading = true
                    var formData = new FormData()
                    // formData.append("callTime",this.callTime)//来电时间
                    formData.append("customer", this.form.customerId) //咨询客户
                    formData.append("adviceType", this.form.adviceType) //咨询类别
                    formData.append("adviceAnswer", this.form.adviceAnswer) //咨询回复
                    formData.append("adviceContent", this.form.adviceContent) //咨询内容
                    formData.append("seatPerson", this.loginName) //受理人员
                    formData.append("callPhone", this.form.counter) //来电号码
                    formData.append("remark", this.remark) //咨询备注
                    if (
                        this.belongAddressId != null &&
                        this.belongAddressId != ""
                    ) {
                        formData.append("belongAddressId", this.belongAddressId)
                    } else {
                        formData.append("belongAddressId", this.form.addressId)
                    }
                    formData.append("belongProvinceId", this.belongProvinceId)
                    metaDataMgrDao.insertAdvicepgd(formData).then((resp) => {
                        if (resp.code == "200") {
                            this.$alert("提交成功", "提交结果", {
                                confirmButtonText: "确定",
                                type: "success",
                                callback: (action) => {
                                    this.$emit("closeAddConsulte", true)
                                    this.loading = false
                                },
                            })
                        } else {
                            this.$alert("提交失败", "提交结果", {
                                confirmButtonText: "确定",
                                type: "warning",
                                callback: (action) => {
                                    this.$emit("closeAddConsulte", true)
                                    this.loading = false
                                },
                            })
                        }
                    })
                } else {
                    console.log("error submit!!")
                    return false
                }
            })
        },
        close() {
            this.$emit("closeAddConsulte", true)
        },
        customerByPhone() {
            var _this = this
            var date = new Date()
            var year = date.getFullYear()
            var month = date.getMonth() + 1 //js中是从0开始所以要加1
            var day = date.getDate()
            var hour = date.getHours()
            var minute = date.getMinutes()
            var second = date.getSeconds()
            this.callTime =
                year +
                "年" +
                month +
                "月" +
                day +
                "日 " +
                hour +
                ":" +
                minute +
                ":" +
                second
            this.form.counter = this.counters
            if (this.counters) {
                var formData = new FormData()
                formData.append("phone", this.counters)
                if (this.belongAddressLevel == "1") {
                    formData.append("belongProvinceId", this.belongProvinceId)
                } else {
                    formData.append("belongAddressId", this.belongAddressId)
                }
                metaDataMgrDao.getCustomerByPhone(formData).then((resp) => {
                    if (resp.code == "200") {
                        if (resp.content != null) {
                            console.log(resp)
                            let list = resp.content
                            console.log(list.name)
                            _this.form.customerId = list.id
                            _this.form.name = list.name
                        } else {
                            this.$message("客户不存在，请新增")
                        }
                    } else if (resp.code == "500") {
                        this.$message("系统异常，请稍后重试")
                    } else {
                        this.$alert("认证失败，重新登录！", "系统提示", {
                            confirmButtonText: "确定",
                            cancelButtonText: "取消",
                            type: "warning",
                            callback: (action) => {
                                this.$router.push({ path: "/login" })
                            },
                        })
                    }
                })
            }
        },
        handleRemove() {},
        handlePreview() {},
        inputClick() {
            this.tableExpand = true
        },
        inputClickClass() {
            this.tableExpandClass = true
        },
        inputClickjms() {
            this.tableExpandjms = true
        },
        inputClickzyz() {
            this.tableExpandzyz = true
        },
        inputClickProduct() {
            this.tableExpandProduct = true
        },
        inputClickName() {
            this.tableExpandName = true
            this.tableLoading = true
            var formData = new FormData()
            formData.append("pageNo", this.pageConfig3.pageNo)
            formData.append("pageSize", this.pageConfig3.pageSize)
            formData.append("name", this.form1.name)
            formData.append("phone", this.form1.phone)
            formData.append("address", this.form1.address)
            formData.append("type", this.form1.type)
            if (this.belongAddressLevel == "1") {
                formData.append("belongProvinceId", this.belongProvinceId)
            } else {
                formData.append("belongAddressId", this.belongAddressId)
            }
            metaDataMgrDao.getCustomers(formData).then((resp) => {
                if (resp.code == "200") {
                    if (resp.content != null) {
                        console.log(resp)
                        this.tableDatas = []
                        let list = resp.content.list
                        let currentPageNo = resp.content.pageNo
                        let currentFirstIndex =
                            (currentPageNo - 1) * this.pageConfig3.pageSize + 1
                        for (let o of list) {
                            o.index = currentFirstIndex
                            o.key = currentFirstIndex
                            currentFirstIndex++
                        }
                        this.pageConfig3.total = resp.content.count
                        this.tableDatas = this.tableDatas.concat(list)
                    } else {
                        console.log(resp)
                        this.tableDatas = []
                        var count = 0
                        this.pageConfig3.total = count
                    }
                } else {
                    this.tableDatas = this.tableDatas.concat(null)
                }
                this.tableLoading = false
                console.log(resp)
            })
        },
        inputClosekName() {
            this.tableExpandName = false
        },
        currentChange3(currentPage) {
            this.pageConfig3.pageNo = currentPage
            this.inputClickName()
        },
        pageSizeChange3(size) {
            this.pageConfig3.pageSize = size
        },
        change(id) {
            this.tableExpandName = false
            var formData = new FormData()
            formData.append("id", id)
            metaDataMgrDao.findCustomersId(formData).then((resp) => {
                if (resp.code == "200") {
                    console.log(resp)
                    let obj = resp.content
                    obj.type = obj.type.toString()
                    this.form = obj
                }
                this.form.customerId = id
                this.form1.customerId = id
                this.tableLoading = false
                console.log(resp)
            })
        },
    },
    mounted: function () {
        if (sessionStorage.getItem("user")) {
            var a = sessionStorage.getItem("user")
            this.belongAddressId = a
            console.log(this.belongAddressId)
        }
        if (sessionStorage.getItem("username")) {
            var username = sessionStorage.getItem("username")
            this.loginName = username
            console.log(this.usernames)
        }
        if (sessionStorage.getItem("belongAddressLevel")) {
            var a = sessionStorage.getItem("belongAddressLevel")
            this.belongAddressLevel = a
            console.log(this.belongAddressLevel)
        }
        if (sessionStorage.getItem("belongProvinceId")) {
            var a = sessionStorage.getItem("belongProvinceId")
            this.belongProvinceId = a
            console.log(this.belongProvinceId)
        }
        setTimeout(() => {
            this.customerByPhone()
        }, 0)
    },
    components: { Paginationmini },
}
</script>

<style lang="less">
.add_infoItem {
    width: 50%;
}
.addOrg-div {
    margin-bottom: 10px;
    .form-label {
        width: 128px;
        display: inline-block;
        text-align: right;
        line-height: 30px;
        margin-right: 10px;
    }
    .form-input {
        width: 68%;
        position: relative;
    }
}
.bottom-btn {
    text-align: center;
    margin-top: 30px;
}
.addOrder-div {
    .el-textarea {
        width: 80%;
    }
}
.table-expand {
    position: absolute;
    z-index: 100;
    width: 33%;
    margin-top: 29px;
    margin-left: 137px;
    border: 1px solid #ccc;
    background: #fff;
    border-radius: 5px;
    .table-search {
        padding-top: 10px;
        display: flex;
        .form-label {
            width: 60px;
        }
        .form-input {
            width: 50%;
        }
    }
    .el-table {
        margin-top: 10px;
    }
}
.expandName {
    width: 50%;
}
</style>